"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * MyBuy Backend API
 * ## Release Notes  ### v0.0.1  Work in progress
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.NavigationToJSON = exports.NavigationFromJSONTyped = exports.NavigationFromJSON = void 0;
var runtime_1 = require("../runtime");
var _1 = require("./");
function NavigationFromJSON(json) {
    return NavigationFromJSONTyped(json, false);
}
exports.NavigationFromJSON = NavigationFromJSON;
function NavigationFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'entries': !(0, runtime_1.exists)(json, 'entries') ? undefined : (json['entries'].map(_1.NavigationEntryFromJSON)),
    };
}
exports.NavigationFromJSONTyped = NavigationFromJSONTyped;
function NavigationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'entries': value.entries === undefined ? undefined : (value.entries.map(_1.NavigationEntryToJSON)),
    };
}
exports.NavigationToJSON = NavigationToJSON;
//# sourceMappingURL=Navigation.js.map